import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import {HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { Device } from '@ionic-native/device/ngx';
import { Keyboard } from '@ionic-native/keyboard/ngx';

import { itemAddToCartpopup } from './custom popup/itemAddToCartpopup/itemAddToCartpopup';
import { FormsModule } from '@angular/forms'; 
import { CommonModule } from '@angular/common'; 
import {DatePipe, DecimalPipe, HashLocationStrategy, LocationStrategy} from '@angular/common';
import { CountryPopup } from './custom popup/countryPopup/countryPopup';
import { schedulePopup } from './custom popup/schedulePopup/schedulePopup';
import { CallNumber } from '@ionic-native/call-number/ngx';
import { DatePicker } from '@ionic-native/date-picker/ngx';
import { PartySizeReservation } from './custom popup/PartySizeReservationPopup/PartySizeReservation';
import { requestNContactPopup } from './custom popup/requestNContactPopup/requestNContactPopup';
import { savedCreditCardPopup } from './custom popup/savedcreditcardPopUp/savedCreditCardPopup';

import { reservationPreSelectMenuPopup } from './custom popup/reservationPreSelectMenuPopup/reservationPreSelectMenuPopup';
import { ComponentsModule } from './components/components.module';
import { PopoverComponent } from './components/popover/popover.component';
import { countryAddressPopup } from './custom popup/countryAddressPopup/countryAddressPopup';
import { stateAddressPopup } from './custom popup/stateAddressPopup/stateAddressPopup';
import { cityAddressPopup } from './custom popup/cityAddressPopup/cityAddressPopup';
import { userAddressListPopup } from './custom popup/userAddressListPopup/userAddressListPopup';
import { MiAccordionComponent } from './widgets/mi-accordion/mi-accordion.component';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { TermsAndConditionsPage } from './terms-and-conditions/terms-and-conditions.page';
import { TimeSelectionComponentComponent } from './components/time-selection-component/time-selection-component.component';
import { OrderTypeSelectionComponent } from './components/order-type-selection/order-type-selection.component';
import { EditTimeSlotSelectionComponent } from './components/edit-time-slot-selection/edit-time-slot-selection.component';

@NgModule({
    declarations: [
        AppComponent,
        itemAddToCartpopup,
        CountryPopup,
        countryAddressPopup,
        stateAddressPopup,
        cityAddressPopup,
        userAddressListPopup,
        schedulePopup,
        PartySizeReservation,
        // requestNContactPopup,
        reservationPreSelectMenuPopup,
        savedCreditCardPopup,
        PopoverComponent,
        MiAccordionComponent,
        TermsAndConditionsPage,
        TimeSelectionComponentComponent,
        OrderTypeSelectionComponent,
        EditTimeSlotSelectionComponent
    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        ComponentsModule,
        CommonModule,
    ],
    providers: [
        StatusBar,
        SplashScreen,
        Device,
        DatePipe,
        DecimalPipe,
        CallNumber,
        DatePicker, Keyboard, Geolocation,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
